// Do not modify manually
export const version = '1.2.1';
//# sourceMappingURL=version.js.map